/**
 * ThemeSwitcher - Toggle between canvas themes
 *
 * Appears at the top of the canvas with a pill-style toggle
 */
import { memo } from 'react';
import { useTheme, type CanvasTheme } from './ThemeContext';

// ============================================================================
// ICONS
// ============================================================================

const ModernIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18" />
    <path d="M9 21V9" />
  </svg>
);

const MacOSIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
    <path d="M12 6v6l4 2" />
  </svg>
);

// ============================================================================
// COMPONENT
// ============================================================================

export const ThemeSwitcher = memo(function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="theme-switcher">
      <button
        type="button"
        onClick={() => setTheme('modern')}
        className={`theme-switcher-btn ${theme === 'modern' ? 'active' : ''}`}
        title="Modern theme"
      >
        <ModernIcon />
        <span>Modern</span>
      </button>
      <button
        type="button"
        onClick={() => setTheme('macos-classic')}
        className={`theme-switcher-btn ${theme === 'macos-classic' ? 'active' : ''}`}
        title="Classic Mac OS theme"
      >
        <MacOSIcon />
        <span>Classic Mac</span>
      </button>

      <style>{`
        .theme-switcher {
          position: absolute;
          top: 16px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 20;
          display: flex;
          gap: 2px;
          padding: 4px;
          background: rgba(255, 255, 255, 0.95);
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
          border: 1px solid rgba(0, 0, 0, 0.1);
          backdrop-filter: blur(10px);
        }

        .theme-switcher-btn {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 8px 14px;
          border-radius: 8px;
          border: none;
          background: transparent;
          color: #666;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .theme-switcher-btn:hover {
          background: rgba(0, 0, 0, 0.05);
          color: #333;
        }

        .theme-switcher-btn.active {
          background: #333;
          color: white;
        }

        .theme-switcher-btn.active:hover {
          background: #444;
          color: white;
        }
      `}</style>
    </div>
  );
});
